var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-group',{attrs:{"multiple":"","show-arrows":""}},[_vm._l((_vm.dates),function(date,index){return [_c('HorizontalDateItem',{key:index,attrs:{"date":date}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }